import { render, staticRenderFns } from "./zbgf.vue?vue&type=template&id=7570deb1&scoped=true"
import script from "./zbgf.vue?vue&type=script&lang=js"
export * from "./zbgf.vue?vue&type=script&lang=js"
import style0 from "./zbgf.vue?vue&type=style&index=0&id=7570deb1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7570deb1",
  null
  
)

export default component.exports